import React, { Component } from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { CampaignFields } from './components/CampaignForm';
import { FormFooter } from '@atlaskit/form';
import { Grid, GridColumn } from '@atlaskit/page';
import { withTranslation, Trans } from 'react-i18next';
import ContentWrapper from '../../components/ContentWrapper';
import { connect } from 'react-redux';
import CampaignActions from '../../redux/CampaignRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import FirmwaresActions from '../../redux/FirmwaresRedux';
import dateFormat from 'dateformat';
import ModalDialog from '@atlaskit/modal-dialog';
import { convertLocalToUtc } from '../../helpers/dateHelper';

class CampaignPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaign: {
                name: '',
                firmware: null,
                startDateTime: Date.now(),
                endDateTime: Date.now(),
                toFactory: false,
            },
            cars: [],
            rules: [],
            notFoundCarVins: [],
            textVins: '',
            parsedVins: [],
            firmwares: [],
            file: null,
            errors: {},
            showModal: false,
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.getCampaign(id);
        this.props.getDictionaries('firmwares');
        this.props.getDictionaries('fotafields');
    }

    componentDidUpdate(prevProps) {
        const { fetching, campaign, fetchingCars, cars } = this.props;

        if (prevProps.fetching && !fetching && !this.props.error) {
            this.setState({
                campaign: campaign,
                cars: cars,
                rules: campaign.filterRules,
                notFoundCarVins: this.props.notFoundCarVins || [],
                firmwares: this.props.dictionaries.firmwares.data || [],
            });
        }

        if (prevProps.fetchingCars && !fetchingCars && !this.props.error) {
            this.setState({
                cars: cars
            });

            const errors = this.validateForm();
            this.setState({ errors: errors });
        }
    }

    onCancel = (e) => {
        e.preventDefault();
        this.props.history.goBack();
    };

    showModal = () => {
        this.setState({ showModal: true });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    };

    onDelete = (e) => {
        this.showModal();
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        const { updateCampaign } = this.props;
        const { cars, campaign, rules } = this.state;

        const carIds = cars.map((c) => c.id);
        const errors = this.validateForm();

        this.setState({ errors: errors });
        if (Object.keys(errors).length > 0)
        {
            return;
        }

        const updatedCampaign = {
            ...campaign,
            startDateTime: dateFormat(campaign.startDateTime, 'isoUtcDateTime'),
            endDateTime: dateFormat(campaign.endDateTime, 'isoUtcDateTime'),
            filterRules: rules,
            carIds,
            firmwareId: campaign.firmware?.id,
        };

        updateCampaign(updatedCampaign);
    };

    onFileChange = (file) => {
        this.setState({ file, cars: [], rules: [] });
        this.props.uploadVinListFile(this.state.campaign?.firmware?.id, file);
    };

    onParseVinText = (e) => {
        this.setState({ cars: [], rules: [] });
        this.props.uploadParsedVins(this.state.campaign?.firmware?.id, this.state.parsedVins);
    };

    onCarsFilter = (e) => {
        this.setState({ cars: [] });
        this.props.uploadCarsFilter(this.state.campaign?.firmware?.id, this.state.rules);
    };

    onChange = (name, value) => {
        if (name === 'rules') {
            this.setState({ rules: value });
        } else if (name === 'textVins') {
            const splitedText = value.split('\n');
            this.setState({ textVins: value, parsedVins: splitedText })
        } else if (name === 'toFactory') {

            this.setState(prevState => ({
                campaign: {
                    ...prevState.campaign,
                    toFactory: value,
                }
            }));

            if (value) {
                this.setState(prevState => ({
                    campaign: {
                        ...prevState.campaign,
                        firmware: null,
                    }
                }));
            }
        } else if (name === 'firmware') {
            this.setState(prevState => ({
                campaign: {
                    ...prevState.campaign,
                    firmware: value,
                    toFactory: false,
                }
            }));
        }
        else {
            this.setState((prevState) => ({
                campaign: { ...prevState.campaign, [name]: value || '' },
            }));
        }
    };

    validateForm = () => {
        const { campaign } = this.state;
        const { t, cars } = this.props;
        const errors = {};

        if (campaign && !campaign.firmware && !campaign.toFactory) {
            errors.firmware = `${t('Firmware')} ${t('Is required')}`;
        }
        if (!cars.length) {
            errors.cars = `${t('Car filter')} ${t('Is required')}`;
        }

        const startDateTime = new Date(campaign.startDateTime).getTime();
        const endDateTime = new Date(campaign.endDateTime).getTime();

        if (startDateTime >= endDateTime) {
            console.log("!!! Ошибка добавляется", campaign.endDateTime, campaign.startDateTime, campaign.endDateTime <= campaign.startDateTime)
            errors.dateEndLess = `${t('End date less than start date')}`;
        }

        return errors;
    };

    render() {
        const { campaign, file, rules, firmwares, errors, cars, parsedVins } = this.state;
        const { fetching, deleteCampaign, dictionaries, t, notFoundCarVins, getDictionaries, fetchingCars, permissions } = this.props;

        return (
            <ContentWrapper>
                <h1>{t('Details Campaign')}</h1>
                <form onSubmit={this.onFormSubmit}>
                    <Grid>
                        <CampaignFields
                            campaign={campaign}
                            file={file}
                            onChange={this.onChange}
                            onFileChange={this.onFileChange}
                            onParseVinText={this.onParseVinText}
                            onCarsFilter={this.onCarsFilter}
                            dictionaries={dictionaries}
                            getDictionaries={getDictionaries}
                            fetchingCars={fetchingCars}
                            fetching={fetching}
                            rules={rules}
                            t={t}
                            cars={cars}
                            notFoundCarVins={notFoundCarVins}
                            firmwares={firmwares}
                            errors={errors}
                            textVins={this.state.textVins}
                            parsedVins={parsedVins}
                        />
                        <GridColumn medium={12}>
                            <FormFooter>
                                {campaign.id && permissions.delete && (

                                    <Button
                                        appearance='subtle'
                                        isDisabled={fetching}
                                        onClick={this.showModal}
                                    >
                                        <span style={{ color: !fetching && 'red' }}>
                                            <Trans>Remove</Trans>
                                        </span>
                                    </Button>)
                                }
                                <ButtonGroup>
                                    <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                                        <Trans>Cancel</Trans>
                                    </Button>
                                    <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='primary'>
                                        <Trans>Save</Trans>
                                    </Button>
                                </ButtonGroup>
                            </FormFooter>
                        </GridColumn>
                    </Grid>
                </form>
                {this.state.showModal && (
                    <ModalDialog
                        heading="Подтверждение"
                        onClose={this.closeModal}
                        actions={[
                            { text: 'Отмена', onClick: this.closeModal },
                            {
                                text: 'Удалить', onClick: (e) => {
                                    this.closeModal();
                                    deleteCampaign(campaign.id);
                                    this.onCancel(e);
                                }
                            },
                        ]}
                    >
                        <p>Вы уверены, что хотите удалить эту кампанию?</p>
                    </ModalDialog>
                )}
            </ContentWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        permissions: state.userProfile.permissions.campaign,
        fetching: state.campaign.fetching,
        campaign: state.campaign.campaign,
        fetchingCars: state.campaign.fetchingCars,
        error: state.campaign.error,
        dictionaries: state.dictionaries,
        cars: state.campaign.cars,
        notFoundCarVins: state.campaign.notFoundCarVins,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCampaign: (id) => dispatch(CampaignActions.campaignRequest(id)),
        deleteCampaign: (id) => dispatch(CampaignActions.deleteCampaignRequest(id)),
        updateCampaign: (campaign) => dispatch(CampaignActions.updateCampaignRequest(campaign)),
        uploadVinListFile: (id, file) => dispatch(CampaignActions.uploadVinFileRequest(id, file)),
        uploadParsedVins: (id, vins) => dispatch(CampaignActions.uploadParsedVinsRequest(id, vins)),
        uploadCarsFilter: (id, rules) => dispatch(CampaignActions.uploadCarsFilterRequest(id, rules)),
        getDictionaries: name => dispatch(DictionariesActions.dictionariesRequest(name)),
        fetchFirmwares: (params) => dispatch(FirmwaresActions.firmwaresRequest(params)),
    };
};

export default withTranslation('fota')(
    connect(mapStateToProps, mapDispatchToProps)(CampaignPage)
);